// extracted by mini-css-extract-plugin
export default {"actions-container":"styles_actions-container__gfDYS"};